module.exports = __webpack_public_path__ + "img/NUMAZU_DISTILLERY_square_white.93fd8c24.png";